<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col
              md="12"
              cols="24"
            >
              <v-text-field
                v-model.number="sortOrder"
                label="Индекс сортировки"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col
              md="12"
              cols="24"
            >
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                :disabled="hasNotPermission('Permissions.MenuCategoryUpdate')"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'
import { hasErrorsForProperty, errorMessages, hasPermission } from '@/helpers'

export default {
  name: 'MenuCategoryForm',
  components: { TranslationFields },
  props: ['save', 'show', 'cancellation', 'label', 'menuVersion'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
    ],
    rules,
    hasErrorsForProperty,
    errorMessages,
  }),
  computed: {
    ...mapFormHandlers('menuCategory/form', [
      'id',
      'translations',
      'menuVersionId',
      'sortOrder',
    ]),
  },
  watch: {
    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('menuCategory/form', ['resetForm']),
    async saveData() {
      this.menuVersionId = this.menuVersion
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
